import { Navigate, Outlet } from 'react-router';

import { useUserRoles } from '../auth/useUserRoles';
import { AdminNav } from './AdminNav';
import { AdminRouteActions } from './AdminRouteActions';
import { HeaderToolbarAndContentLayout } from 'src/common/primitives/HeaderToolbarAndContentLayout';

export function AdminLayout() {
  const { isBambi } = useUserRoles();

  if (!isBambi) {
    return <Navigate to="/" />;
  }

  return (
    <HeaderToolbarAndContentLayout
      preContent={<AdminNav />}
      actionSection={<AdminRouteActions />}
      content={<Outlet />}
    />
  );
}
